import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabelV2 from '../../../../components/composite/FormSets/InputWithLabelV2/InputWithLabelV2';

const EmailPasswordControlSet = ({
  email,
  setEmail,
  password,
  setPassword,
}) => (
  <>
    <InputWithLabelV2
      id="email"
      label="Email"
      value={email || ''}
      maxLength="150"
      type="email"
      onChange={({ target: { value } }) => setEmail(value)}
    />

    <InputWithLabelV2
      id="password"
      label="Password"
      value={password || ''}
      maxLength="72"
      type="password"
      onChange={({ target: { value } }) => setPassword(value)}
    />
  </>
);

EmailPasswordControlSet.propTypes = {
  email: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
};

export default EmailPasswordControlSet;
